import React, { FC } from "react";
import { Text } from "@fluentui/react-components";
import { Warning24Regular } from "@fluentui/react-icons";
import "./Banner.scss";

export interface IBannerProps {

}

export const Banner: FC<IBannerProps> = (props) => {
    return (
        <div className="c-banner">
            <div className="c-iconContainer">
                <Warning24Regular className="c-warning-icon"/>
            </div>
            <div className="c-textContainer">
                <Text>
                    UHF is currently undergoing a vNext redesign, slated to launch in FY25. The current version of UHF is in sustain mode and only compliance updates will be made. vNext feature requests can be submitted via aka.ms/askmartech.
                </Text>
            </div>
        </div>
    );
}